export default () => ({
  numMerchants: 0,
  currentMerchant: null,
  merchants: [],
  merchantLoading: false,
  numCustomers: 0,
  currentCustomer: {},
  customers: [],
  customerLoading: false,
  recentPaymentLoading: false,
  numAccounts: 0,
  accounts: [],
  accountLoading: false,
  pageTitle: [],
  csvData: {},
  isRefreshComplete: false,
  startupLoadError: null,
  currentAccount: {},
  locations: [],
  currentLocation: {},
  selectedLocation: {},
  group: null,
  users: [],
  accountTags: [],
  failedActions: [],
  receiptModalOpen: false,
  currentPayment: null,
  accountPromises: [],
  accountPromisesLoading: false,
  roleLoading: false,
  role: {},
  dashboardDateRange: {},
  isSideNavOpen: true,
  isReportsFlyoutOpen: false,
  starredReports: [],
  uiPreferences: {},
  aiBatchConfigs: [],
  aiBatchConfigsCount: 0,
  aiBatchConfigsLoading: false,
  aiCallerAgents: [],
  aiCallerAgentsLoading: false,
  aiCallerBatches: [],
  aiCallerBatchesCount: 0,
  aiCallerBatchesLoading: false
})
